export const CLEAR_MODAL = 'CLEAR_MODAL';
export type CLEAR_MODAL = typeof CLEAR_MODAL;



// WEBPACK FOOTER //
// ./src/actions/modal/clear/Types.tsx